import './App.css';
import React from 'react';
import  GlobalStyle from './Style/GlobalStyle';
import {Layout} from "./component/Layout";

function App() {
  return (
    <div>
      <Layout/>
      <GlobalStyle />
      
    </div>
  );
}

export default App;
